/*
 * Options Messages
 *
 * This contains all the text for the Options component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingPlan: {
    id: 'cwt.translations.Options.LoadingPlan',
    defaultMessage: 'Loading Worktop',
  },
  mmUnit: {
    id: 'cwt.translations.MilimeterUnit',
    defaultMessage: 'mm',
  },
  inUnit: {
    id: 'cwt.translations.InchesUnit',
    defaultMessage: '“',
  },
});
